import React, { useState, useRef } from "react";
import { motion, useInView } from "framer-motion";
import styles from "./CaptureMoment.module.css";
// import RenderCamera from "./CameraRender/RenderCamera";
import BudgetCalculator from "../BudgetCalculator/BudgetCalculator";
import ParallaxGallery from "../ParallaxGallery";


const isMobile = window.innerWidth < 768; // Check if it's a mobile device

// Smooth spring animation for Desktop
const springCurve = {
  type: "spring",
  stiffness: 120,
  damping: 20,
  mass: 1,
};

// Simple fade-in for Mobile
const fadeIn = (delay = 0) => ({
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, delay } },
});

// Desktop animation (complex)
const slideIn = (direction, delay = 0) => ({
  hidden: {
    opacity: 0,
    x: direction === "left" ? -150 : direction === "right" ? 150 : 0,
    y: direction === "up" ? 150 : direction === "down" ? -150 : 0,
    scale: isMobile ? 1 : 0.9, // No scale effect on mobile
  },
  show: {
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    transition: isMobile ? { duration: 0.5, delay } : { ...springCurve, delay },
  },
});

const CaptureMoment = () => {
  const [isCalculatorOpen, setCalculatorOpen] = useState(false);

  // Reference to the CaptureMoment section
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.3 });

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      // Use requestAnimationFrame for a smoother scroll
      window.requestAnimationFrame(() => {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  };
  

  return (
    <motion.div
      ref={sectionRef}
      className={styles.container}
      id="captureMoment"
      initial="hidden"
      animate={isInView ? "show" : "hidden"}
    >
      {/* Left Section */}
      <motion.div
        className={styles.leftContainer}
        variants={isMobile ? fadeIn(0.2) : slideIn("left", 0.2)}
      >
        <motion.div
          className={styles.leftTopContent}
          variants={isMobile ? fadeIn(0.4) : slideIn("up", 0.4)}
        >
          <motion.h6 variants={isMobile ? fadeIn(0.6) : slideIn("up", 0.6)}>
            At <strong>Maa Mangala Studio</strong>, we capture the magic of your
            special moments with a blend of{" "}
            <strong>creativity, passion, and cinematic excellence.</strong> Whether it’s your{" "}
            <strong>wedding, engagement, or a special event</strong>, our expert team ensures every frame tells a beautiful story.
          </motion.h6>
          
          <motion.button
            className={styles.glowingButton}
            whileHover={!isMobile ? { scale: 1.15, rotate: 2 } : {}}
            whileTap={!isMobile ? { scale: 0.95 } : {}}
            onClick={() => scrollToSection("contactForm")}
          >
            Connect With Us
          </motion.button>
       
        </motion.div>
        <motion.div
          className={styles.leftContent}
          variants={isMobile ? fadeIn(0.8) : slideIn("up", 0.8)}
        >
          <img
            src="https://studiomaamangala.com/wp-content/uploads/2025/02/michael-soledad-jiOByhCw2jE-unsplash-scaled.jpg"
            alt="Capture"
          />
        </motion.div>
      </motion.div>

      {/* Right Section */}
      <motion.div
        className={styles.rightContainer}
        variants={isMobile ? fadeIn(0.3) : slideIn("right", 0.3)}
      >
        <motion.div
          className={styles.rightTopContent}
          variants={isMobile ? fadeIn(0.5) : slideIn("right", 0.5)}
        >
          {/* <RenderCamera /> */}
          <ParallaxGallery/>
        </motion.div>
        <motion.div
          className={styles.rightBottomContent}
          variants={isMobile ? fadeIn(0.7) : slideIn("up", 0.7)}
        >
          <div className={styles.rightContentWrapper}>
            <motion.h6 variants={isMobile ? fadeIn(0.8) : slideIn("up", 0.8)}>
              Every Moment, A Beautiful Story
            </motion.h6>
            <motion.p variants={isMobile ? fadeIn(1) : slideIn("up", 1)}>
              <strong>Maa Mangala Studio</strong> is your ultimate destination
              for capturing timeless memories. With years of experience in{" "}
              <strong>wedding photography, cinematography, and creative portraits</strong>,
              we bring a perfect balance of emotion and artistry to your most precious occasions.
            </motion.p>
            <motion.button
              className={styles.glowingButton}
              whileHover={!isMobile ? { scale: 1.15, rotate: 2 } : {}}
              whileTap={!isMobile ? { scale: 0.95 } : {}}
              onClick={() => setCalculatorOpen(true)}
            >
              Calculate Budget →
            </motion.button>
          </div>
        </motion.div>
      </motion.div>

      {isCalculatorOpen && (
     
          <BudgetCalculator onClose={() => setCalculatorOpen(false)} />
 
      )}
    </motion.div>
  );
};

export default CaptureMoment;
